export type VoidFunc = () => void;

export const voidFunc: VoidFunc = () => {
  /**/
};
